document.addEventListener("turbo:load", function () {
  const messageBoxes = document.querySelector("[data-dismiss]");

  if (messageBoxes) {
    messageBoxes.addEventListener("click", (e) => {
      e.target.parentNode.remove();
    });
  }
});
